export default "//static.tradera.net/touchweb/static/output/images/category-video-computer-games.85def0f0.svg";